export default __webpack_public_path__ + "static/media/gritr.77d70a4e.jpg";